import { MouseEvent, ReactNode } from 'react';

export interface FooterLinkProps {
  /** Link URL */
  href: string;
  /** Link text or React node */
  label: ReactNode;
  /** Screen reader label - uses label if not provided */
  ariaLabel?: string;
  /** Extra CSS classes */
  className?: string;
  /** Click handler */
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  /** Open the link in a new browser tab */
  openInNewTab?: boolean;
  /** Test ID for automated testing */
  'data-testid'?: string;
}

export type FooterLink = FooterLinkProps;

export const FooterLink = (props: FooterLinkProps) => {
  const { href, label, ariaLabel, className, onClick, openInNewTab, 'data-testid': dataTestId } = props;
  const baseTestId = dataTestId ?? 'footer-link';

  return (
    <li data-testid={baseTestId}>
      <a
        data-testid={`${baseTestId}-anchor`}
        href={href}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        target={openInNewTab ? '_blank' : undefined}
        {...(ariaLabel && { 'aria-label': ariaLabel })}
        {...(className && { className: className })}
        {...(onClick && { onClick: onClick })}>
        {label}
      </a>
    </li>
  );
};
